import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from '@material-ui/core/Button';
import { bridgeBillingOpenBilling } from '../../../slices/BridgeSlice';
import './TrialEndedBanner.scss';
import IntlMessages from 'util/IntlMessages';
import { useLocalizedMessage } from 'util/useLocalizedMessage';


export default function TrialEndedBanner({ }) {
  const t = useLocalizedMessage();
  const dispatch = useDispatch();

  const {
    billing: {
      plans: {
        isFetching = true,
        active: activeCharges = [],
        app: appInfo = {},
      } = {},
    } = {},
    settings: {
      platformSettings: { bridgeApplicable = false } = {},
    } = {},
  } = useSelector((store) => store);

  const hasActiveSub = useMemo(
    () => (activeCharges || []).some((c) => c?.status === 'active'),
    [activeCharges]
  );

  const status = appInfo?.status;
  const daysLeftRaw = appInfo?.trialDaysLeft;
  const daysLeft = Number.isFinite(daysLeftRaw) ? daysLeftRaw : undefined;

  const isTrialPhase = useMemo(
    () => ['TRIAL', 'INTEGRATION', 'TRIAL_LAST_CALL'].includes(status),
    [status]
  );
  const isDisabled = useMemo(
    () => ['ACTIVE_SWITCHED_OFF', 'SWITCH_OFF'].includes(status),
    [status]
  );

  const showTrialEnded =
    bridgeApplicable &&
    !isFetching &&
    !hasActiveSub &&
    isTrialPhase &&
    Number.isFinite(daysLeft) &&
    daysLeft <= 0;

  const showDisabled =
    bridgeApplicable &&
    !isFetching &&
    isDisabled;

  if (!showTrialEnded && !showDisabled) return null;

  const handleOpenBilling = () => dispatch(bridgeBillingOpenBilling());

  const themeClass = showDisabled ? 'trial-ended-banner--error' : 'trial-ended-banner--warning';
  const titleText = t(showDisabled ? 'billing.banner.serviceDisabled' : 'billing.banner.trialEnded');
  const descText = showDisabled
    ? t('billing.banner.serviceDisabledDescription')
    : t('billing.banner.trialEndedDescription');

  return (
    <div className={`trial-ended-banner ${themeClass}`}>
      <div className="trial-ended-banner__container container">
        <div className="row align-items-center">
          <div className="col-md-8">
            <div className="trial-ended-banner__title">{titleText}</div>
            <div className="trial-ended-banner__desc">{descText}</div>
          </div>
          <div className="col-md-4 d-flex justify-content-md-end mt-3 mt-md-0">
            <Button
              variant="contained"
              color="primary"
              onClick={handleOpenBilling}
              className="trial-ended-banner__cta"
            >
              <IntlMessages id="ui.kea.trialEndedBanner.trialEndedBanner.openBilling" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
